module.exports = __webpack_public_path__ + "media/assets/icons/pagenavicon_point-a90ccaa31698ddb5c11b5310477f945c.svg";